module.exports = __webpack_public_path__ + "assets/fonts/67fd47d9-18cd-4e79-87e4-e0251c4cd08c.de772380.woff2";